export default __webpack_public_path__ + "static/customer1-31a287fc721d7c94c11a31ae43b4c063.jpg";